module.exports = __webpack_public_path__ + "media/images/default/shared/left-arrow-a93f247148fe505d0b36481b01daf1e5.svg";